export default "__VITE_ASSET__AyB9wz$j__"